import { render, staticRenderFns } from "./ShopCubes.vue?vue&type=template&id=0522b985&scoped=true&"
import script from "./ShopCubes.vue?vue&type=script&lang=js&"
export * from "./ShopCubes.vue?vue&type=script&lang=js&"
import style0 from "./ShopCubes.vue?vue&type=style&index=0&id=0522b985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522b985",
  null
  
)

export default component.exports